var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    enableBackground: "new 0 0 20 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#5964FF",
    d: "M2.827,0.721h14.347c0.277,0,0.463,0.231,0.463,0.463v17.632c0,0.277-0.232,0.463-0.463,0.463H2.827 c-0.278,0-0.463-0.232-0.463-0.463V1.184C2.364,0.906,2.595,0.721,2.827,0.721z M16.711,1.647H3.289v16.707h13.422V1.647z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5964FF",
    d: "M4.4,3.174h5.044c0.278,0,0.463,0.185,0.463,0.463v5.044c0,0.278-0.185,0.462-0.463,0.462H4.4 c-0.277,0-0.463-0.231-0.463-0.462V3.637C3.937,3.359,4.123,3.174,4.4,3.174z M8.981,4.1H4.863v4.119h4.119V4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.465,6.46c-0.186-0.185-0.186-0.463,0-0.648c0.185-0.185,0.462-0.185,0.647,0l0.417,0.417l1.203-1.157 c0.186-0.186,0.463-0.186,0.648,0c0.185,0.185,0.185,0.462,0,0.647L6.899,7.2c-0.185,0.186-0.509,0.186-0.694,0L5.465,6.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5964FF",
    d: "M4.4,10.855h5.044c0.278,0,0.463,0.232,0.463,0.463v5.045c0,0.277-0.185,0.463-0.463,0.463H4.4 c-0.277,0-0.463-0.186-0.463-0.463v-5.045C3.937,11.041,4.123,10.855,4.4,10.855z M8.981,11.781H4.863V15.9h4.119V11.781z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.465,14.189c-0.186-0.186-0.186-0.465,0-0.648c0.185-0.186,0.462-0.186,0.647,0l0.417,0.416l1.203-1.156 c0.186-0.186,0.463-0.186,0.648,0c0.185,0.139,0.185,0.461,0,0.646L6.899,14.93c-0.185,0.186-0.509,0.186-0.694,0L5.465,14.189z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5964FF",
    d: "M11.666,5.025c-0.23,0-0.463-0.231-0.463-0.463c0-0.278,0.232-0.463,0.463-0.463H15.6 c0.277,0,0.463,0.185,0.463,0.463c0,0.231-0.186,0.463-0.463,0.463H11.666z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5964FF",
    d: "M11.666,8.219c-0.23,0-0.463-0.231-0.463-0.463c0-0.278,0.232-0.463,0.463-0.463H15.6 c0.277,0,0.463,0.186,0.463,0.463c0,0.231-0.186,0.463-0.463,0.463H11.666z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5964FF",
    d: "M11.666,12.707c-0.23,0-0.463-0.186-0.463-0.463c0-0.23,0.232-0.463,0.463-0.463H15.6 c0.277,0,0.463,0.232,0.463,0.463c0,0.277-0.186,0.463-0.463,0.463H11.666z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5964FF",
    d: "M11.666,15.9c-0.23,0-0.463-0.184-0.463-0.463c0-0.23,0.232-0.463,0.463-0.463H15.6 c0.277,0,0.463,0.232,0.463,0.463c0,0.279-0.186,0.463-0.463,0.463H11.666z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.3b8795d52d66fa6422c92a765b64d558.svg";
export { ForwardRef as ReactComponent };